import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  totalAmount: "10000",
  taxSlab: "12",
  vatType: "excluding",
  // vatValue: 0,
  vatErrors: null
};

const vatSlice = createSlice({
  name: 'vatCalculator',
  initialState,
  reducers: {
    setTotalAmount: (state, action) => {
      state.totalAmount = action.payload;
    },
    setTaxSlab: (state, action) => {
      state.taxSlab = action.payload;
    },
    setVatType: (state, action) => {
      state.vatType = action.payload;
    },
    setVatValue: (state, action) => {
      state.vatValue = action.payload;
    },
    setVatErrors: (state, action) => {
      state.vatErrors = action.payload;
    },
    resetVatFields: (state) => {
      state.totalAmount = "";
      state.taxSlab = "";
      state.vatType = "";
      state.vatValue = "";
      state.vatErrors = null;
    },
      resetVatData: (state) => {
          return initialState;
        },
  }
});

export const {
  setTotalAmount,
  setTaxSlab,
  setVatType,
  setVatValue,
  setVatErrors,
  resetVatFields,resetVatData
} = vatSlice.actions;

export default vatSlice.reducer;